import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import moment from 'moment';
import { TherapistService } from '../../../../../../services/TherapistService';
import { AppointmentService } from '../../../../../../services/AppointmentService';
import { Util } from '../../../../../../Util';
import { Repeat } from '../../../../../../models/Appointment';
import { TwitterPicker } from 'react-color';
import CustomTimePicker from '../../../../../../components/CustomTimePicker';
import DatePicker from 'react-date-picker';
import { toast } from 'react-toastify';
import UserContext from '../../../../../../context/UserContext';
import momentTimezone from 'moment-timezone';

const SchedulingCalendar = ({ isOpen, onClose, meetingInfo, noFollowUpReason, isTentativeAppointment: propIsTentativeAppointment }) => {
  const [loggedUser] = useContext(UserContext);
  
  // Calendar states
  const [appointments, setAppointments] = useState([]);
  const [blockDatesList, setBlockDatesList] = useState([]);
  const [timeValue, setTimeValue] = useState("");
  const [hourValue, setHourValue] = useState(0);
  const [minuteValue, setMinuteValue] = useState(0);
  const [therapistDetails, setTherapistDetails] = useState({});
  const [workingDaysOfTherapist, setWorkingDaysOfTherapist] = useState([]);
  const [isHours, setIsHours] = useState([]);
  const [isAvailableHours, setIsAvailableHours] = useState([]);
  const [isEventModal, setIsEventModal] = useState(false);
  const [isEventViewModal, setIsEventViewModal] = useState(false);
  const [isEventTimeValidationViewModal, setIsEventTimeValidationViewModal] = useState(false);
  const [errorModalText, setErrorModalText] = useState("");
  const [disabledCreateBtn, setDisabledCreateBtn] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [appointment, setAppointment] = useState({
    id: "",
    title: "Lavni Therapy session",
    startTime: "",
    endTime: "",
    date: "",
    repeat: Repeat.DOES_NOT_REPEAT,
    color: propIsTentativeAppointment ? "#6c757d" : "#FF6900",
    therapist: {},
    client: {},
    selectedDate: "",
  });
  const [haveRead, setHaveRead] = useState(false);
  const [haveAgreed, setHaveAgreed] = useState(false);
  const [haveAgreedPolicy, setHaveAgreedPolicy] = useState(false);
  const [isTentativeAppointment, setIsTentativeAppointment] = useState(propIsTentativeAppointment || false);
  const [appointmentDetails, setAppointmentDetails] = useState();

  // Calendar helper functions
  const dayOfWeekAsNumber = (day) => {
    return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(day);
  };

  const createHoursForTimeSlots = () => {
    const hours = [];
    for (let hour = 0; hour < 24; hour++) {
      hours.push(moment({ hour }).format("H:mm A"));
      hours.push(moment({ hour, minute: 30 }).format("H:mm A"));
    }
    setIsHours(hours);
  };

  const getAvailableTimeBySelectedDay = (dayNumber, isAvailableHours) => {
    const availableHours = [];
    isAvailableHours
      .filter((obj) => obj.daysOfWeek[0] === dayNumber)
      .map((obj) => {
        for (let hour = parseInt(obj.startTime); hour <= parseInt(obj.endTime); hour++) {
          if (hour == parseInt(obj.startTime)) {
            const mST = moment(obj.startTime, "HH:mm").minute();
            if (mST == 0) {
              availableHours.push(moment({ hour }).format("H:mm A"));
            }
          } else {
            availableHours.push(moment({ hour }).format("H:mm A"));
          }

          if (hour != parseInt(obj.endTime)) {
            availableHours.push(moment({ hour, minute: 30 }).format("H:mm A"));
          } else {
            const mET = moment(obj.endTime, "HH:mm").minute();
            if (mET == 30) {
              availableHours.push(moment({ hour, minute: 30 }).format("H:mm A"));
            }
          }
        }
      });
    return availableHours;
  };

  const getWorkingDaysOfWeek = (workingHours) => {
    const workingDays = [];
    workingHours?.map((session) => {
      if (!workingDays.includes(session.day)) workingDays.push(session.day);
    });
    const dup = [...new Set(workingDays)];
    setWorkingDaysOfTherapist(dup);
  };

  const checkAvailableTime = (workingHoursOfTherapist) => {
    const availableDays = [];
    if (workingHoursOfTherapist?.length) {
      workingHoursOfTherapist?.map((obj) => {
        const dayAsNumber = dayOfWeekAsNumber(obj.day);
        if (Util.convertUTCDateToLocalDate(obj.endTime) > Util.convertUTCDateToLocalDate(obj.startTime)) {
          return availableDays.push({
            startTime: Util.convertUTCDateToLocalDate(obj.startTime),
            endTime: Util.convertUTCDateToLocalDate(obj.endTime),
            daysOfWeek: [dayAsNumber],
          });
        } else {
          availableDays.push({
            startTime: Util.convertUTCDateToLocalDate(obj.startTime),
            endTime: "24:00 AM",
            daysOfWeek: [dayAsNumber - 1],
          });
          return availableDays.push({
            startTime: "00:00 AM",
            endTime: Util.convertUTCDateToLocalDate(obj.endTime),
            daysOfWeek: [dayAsNumber],
          });
        }
      });
    } else {
      availableDays.push({
        startTime: "00:00 AM",
        endTime: "00:00 PM",
        daysOfWeek: [10],
      });
    }
    setIsAvailableHours(availableDays);
    return availableDays;
  };

  const loadTherapistDetails = async () => {
    try {
      const response = await TherapistService.getTherapistDetailsbyIdAdmin(loggedUser._id, meetingInfo?.clientId);
      if (response.success) {
        setTherapistDetails(response.data);
        checkAvailableTime(response.data?.workingHours);
        getWorkingDaysOfWeek(response.data?.workingHours);
        
        const blockedSlots = response.data?.blockedDates || [];
        setBlockDatesList(blockedSlots);
        
        getAllAppointmentsByTherapistId(blockedSlots);
      }
    } catch (error) {
      console.error("Error loading therapist details:", error);
    }
  };

  const getAllAppointmentsByTherapistId = async (blockedSlots = []) => {
    try {
      const response = await AppointmentService.getAllAppointmentByTherapistIdAdmin(loggedUser._id);
      if (response.success) {
        response.data.map((item) => {
          if (item.clientId?._id !== meetingInfo?.clientId) {
            item.color = "#665a5a";
          }
        });
        setAppointments([...response.data, ...blockedSlots]);
      }
    } catch (error) {
      console.error("Error loading appointments:", error);
    }
  };

  const addEvent = (selectedDetails) => {
    const selectedDate = moment(selectedDetails?.startStr).toISOString();
    const isInRange = blockDatesList.some(range => {
      return Util.isDateInBlockedRange(moment(range?.start), moment(range?.end), moment(selectedDate));
    });

    if (isInRange) {
      return false;
    }

    setIsUpdate(false);
    openCreateAppointmentPopup(selectedDetails);
  };

  const openCreateAppointmentPopup = (selectedDetails) => {
    if (!selectedDetails.start) {
      return toast.error("Please select valid date.", {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
    }

    if (!moment(new Date()).isBefore(moment(selectedDetails.start))) {
      return toast.error("Sorry! You can't create appointment in a past date!", {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
    }

    setTimeValue(selectedDetails.start.toString());
    setHourValue(moment(selectedDetails.start).hour());
    setMinuteValue(moment(selectedDetails.start).minute());

    setAppointment({
      ...appointment,
      date: moment(selectedDetails?.start).format(),
      startTime: moment(selectedDetails?.start).format("H:mm A"),
      endTime: moment(selectedDetails?.start).add(60, "minutes").format("H:mm A"),
      selectedDate: moment(selectedDetails?.start).toISOString(),
    });

    setIsEventModal(true);
  };

  const createAppointment = async () => {
    const selectedDate = moment(appointment.selectedDate);

    if (selectedDate.minutes() != 0 && selectedDate.minutes() != 30) {
      setErrorModalText("You have selected invalid time.");
      return setIsEventTimeValidationViewModal(true);
    }

    const isInRange = blockDatesList.some(range => {
      return Util.isDateInBlockedRange(moment(range.start), moment(range.end), moment(selectedDate.toISOString()));
    });

    if (isInRange) {
      setErrorModalText(`Sorry! Therapist has blocked this date.`);
      return setIsEventTimeValidationViewModal(true);
    }

    if (!appointment.startTime) {
      return toast.error("Please select valid start time.", {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
    }

    if (!appointment.date) {
      return toast.error("Please select valid date.", {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
    }

    if (!appointment.title) {
      return toast.error("Please add title.", {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
    }

    if (!moment(new Date()).isBefore(moment(new Date(appointment.date).setHours(parseInt(appointment.startTime.split(":")[0]), parseInt(appointment.startTime.split(":")[1]), 0, 0)))) {
      return toast.error("Sorry! You can't create appointment in a past date!", {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
    }

    setDisabledCreateBtn(true);

    const appointmentObj = {
      therapistId: loggedUser._id,
      clientId: meetingInfo?.clientId,
      start: new Date(new Date(appointment.date).setHours(parseInt(appointment.startTime.split(":")[0]), parseInt(appointment.startTime.split(":")[1]), 0, 0)),
      end: new Date(new Date(appointment.date).setHours(parseInt(appointment.endTime.split(":")[0]), parseInt(appointment.endTime.split(":")[1]), 0, 0)),
      reminders: [30],
      title: appointment.title,
      repeatInfo: {
        repeatType: appointment.repeat,
        interval: "",
        repeatDays: {
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
        },
        endingDate: Util.monthsNextFrom(new Date(appointment.date), 1),
        endingAfter: 10,
        endingType: "",
      },
      color: appointment.color,
      groupId: meetingInfo?.clientId + "_" + Util.dateConvertToMilisecond(new Date(new Date(appointment.date).setHours(parseInt(appointment.startTime.split(":")[0]), parseInt(appointment.startTime.split(":")[1]), 0, 0))),
      eventOnHolidays: false,
      isTentativeAppointment: isTentativeAppointment,
    };

    try {
      const response = await AppointmentService.createAppointmentByAdmin(appointmentObj);
      if (response.success) {
        setHaveRead(false);
        setHaveAgreed(false);
        setHaveAgreedPolicy(false);
        setIsTentativeAppointment(false);
        setIsEventModal(false);
        getAllAppointmentsByTherapistId();
        
        toast.success("Appointment created successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
        
        onClose();
      } else {
        setErrorModalText(response.error);
        setIsEventTimeValidationViewModal(true);
      }
    } catch (error) {
      setErrorModalText(error.message);
      setIsEventTimeValidationViewModal(true);
    }
    
    setDisabledCreateBtn(false);
  };

  const viewEvent = async (event) => {
    const appointmentId = event.event._def.extendedProps._id;
    try {
      const response = await AppointmentService.viewSingleAppointmentAdmin(appointmentId);
      if (response.success) {
        setAppointmentDetails(response.data);
        setIsEventViewModal(true);
      } else {
        setErrorModalText(response.error);
        setIsEventTimeValidationViewModal(true);
      }
    } catch (error) {
      setErrorModalText(error.message);
      setIsEventTimeValidationViewModal(true);
    }
  };

  const handleChangeComplete = (color) => {
    setAppointment({...appointment, color: color.hex});
  };

  const eventModalToggle = () => {
    setIsEventModal(!isEventModal);
  };

  const eventViewModalToggle = () => {
    setIsEventViewModal(!isEventViewModal);
  };

  const eventTimeValidationModalToggle = () => {
    setIsEventTimeValidationViewModal(!isEventTimeValidationViewModal);
    setErrorModalText("");
  };

  // Load calendar data when modal opens
  useEffect(() => {
    if (isOpen && meetingInfo?.clientId) {
      createHoursForTimeSlots();
      loadTherapistDetails();
      // Update tentative appointment state when prop changes
      setIsTentativeAppointment(propIsTentativeAppointment || false);
      // Update appointment color based on tentative state
      setAppointment(prev => ({
        ...prev,
        color: propIsTentativeAppointment ? "#6c757d" : "#FF6900"
      }));
    }
  }, [isOpen, meetingInfo, propIsTentativeAppointment]);

  return (
    <>
      {/* Main Scheduling Modal */}
      <Modal isOpen={isOpen} backdrop="static" keyboard={false} centered size="xl">
        <div className="modal-header">
          <h5 className="modal-title">
            {noFollowUpReason === 'clientPause' 
              ? "Please choose a tentative follow-up appointment date so we can follow up and keep the client engaged."
              : noFollowUpReason === 'therapistUnavailable'
              ? "Please choose a tentative follow-up appointment date so the client is informed and remains engaged."
              : "Schedule an appointment - Click to Schedule"
            }
          </h5>
          <button 
            type="button" 
            className="btn-close" 
            onClick={onClose}
            style={{ background: "none", border: "none", fontSize: "1.5rem" }}
          >
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-3">
              <div id="external-events">
                <Label className="mb-2 d-flex">
                  <span>Therapist</span>
                  <i className="bx bxs-down-arrow mr-2 more-icon"></i>
                </Label>
                <div className="card">
                  <div className="col-xl-12">
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="row">
                          <div className="col">
                            <div 
                              className="profileImage-appoint imageFit BorderRadiusLeftRight" 
                              style={{ 
                                backgroundImage: therapistDetails?.coverPhotoId ? `url("${Util.fileURL(therapistDetails.coverPhotoId._id)}")` : `url('/default-cover.png')`,
                                height: "150px",
                                backgroundSize: "cover",
                                backgroundPosition: "center"
                              }}
                            />
                            <div className="row">
                              <div className="col-lg-4 col-xl-4">
                                <div className="avatar-md profile-user-wid mb-4">
                                  <div 
                                    className="img-thumbnail avatar-md profileImageShow rounded-circle imageFit mr-profile" 
                                    style={{ 
                                      backgroundImage: therapistDetails?.photoId ? `url("${Util.fileURL(therapistDetails.photoId._id)}")` : `url('/default-profile.png')`,
                                      width: "60px",
                                      height: "60px",
                                      backgroundSize: "cover",
                                      backgroundPosition: "center",
                                      borderRadius: "10px"
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-8 col-xl-8">
                                <span className="appointment-profile-name2">
                                  {therapistDetails?.firstname} {therapistDetails?.lastname}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12">
                            <div className="working-hours">
                              <Label className="px-2">
                                <i className="bx bx-time-five"></i> &nbsp;Working Hours:
                              </Label>
                              <div className="working-hours">
                                {therapistDetails?.workingHours &&
                                  therapistDetails.workingHours.map((opt, index) => (
                                    <Label className="flex-wrap -mx-2 md:space-y-0 mt-2 px-2" key={index}>
                                      {opt.day} {opt.day && "|"} {Util.convertUTCDateToLocalDate(opt.startTime)} - {Util.convertUTCDateToLocalDate(opt.endTime)}
                                    </Label>
                                  ))}
                                {!therapistDetails?.workingHours?.length && <p>No working hours added.</p>}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-lg-9">
              <FullCalendar
                plugins={[bootstrapPlugin, dayGridPlugin, interactionPlugin, timeGridPlugin]}
                slotMinTime={15}
                editable={false}
                slotDuration={"00:30:00"}
                handleWindowResize={true}
                themeSystem="bootstrap"
                headerToolbar={{
                  left: "prev,next today",
                  center: "title",
                  right: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
                eventTimeFormat={{
                  hour12: false,
                }}
                firstDay={dayOfWeekAsNumber(moment(new Date()).format("dddd"))}
                initialView="timeGridWeek"
                selectLongPressDelay={-1}
                longPressDelay={-1}
                eventLongPressDelay={-1}
                events={appointments.map(appointment => {
                  const startMoment = momentTimezone(appointment.start).tz('America/New_York');
                  const endMoment = momentTimezone(appointment.end).tz('America/New_York');
                  const startOffset = startMoment.isDST() ? -4 * 60 : -5 * 60;
                  const endOffset = endMoment.isDST() ? -4 * 60 : -5 * 60;
                  return {
                    ...appointment,
                    start: startMoment.utcOffset(startOffset, true).toDate(),
                    end: endMoment.utcOffset(endOffset, true).toDate()
                  };
                })}
                droppable={false}
                selectable={true}
                eventClick={viewEvent}
                select={addEvent}
                businessHours={isAvailableHours}
              />
            </div>
          </div>
          <div className="text-center mt-3 mb-3">
            <p className="text-muted">Click on a time-slot to schedule appointment</p>
          </div>
        </div>
        <div className="modal-footer">
          <Button color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={onClose}
            style={{
              backgroundColor: "#F47B20",
              border: "none"
            }}
          >
            Done
          </Button>
        </div>
      </Modal>

      {/* Create Appointment Modal */}
      <Modal isOpen={isEventModal} centered toggle={eventModalToggle}>
        <div className="modal-header">
          <div className="title-input">
            <FormGroup>
              <Input
                className="modal-title new-input-v"
                name="title"
                type="text"
                placeholder="Add title - Optional"
                onChange={e => setAppointment({ ...appointment, title: e.target.value })}
                value={appointment.title}
              />
              <span className="awsome_input_border" />
            </FormGroup>
          </div>
        </div>
        <div className="modal-body awsome-area">
          <div className="row mb-4">
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center sm-hide">
              <i className="bx bx-time-five"></i>
            </div>
            <div className="col-lg-11 col-md-11 col-sm-11 col-xs-12">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 sm-mb5">
                  <DatePicker
                    minDate={moment().toDate()}
                    value={moment(appointment?.date).toDate()}
                    onChange={(date) => {
                      const selectedTime = moment(date);
                      selectedTime.hour(hourValue).minute(minuteValue);
                      const stateT = moment(selectedTime).format("H:mm A");
                      const endT = moment(selectedTime).add(60, "minutes").format("H:mm A");
                      const sDate = moment(selectedTime).toISOString();
                      setAppointment({ ...appointment, startTime: stateT, endTime: endT, selectedDate: sDate, date: selectedTime.format("YYYY/MM/DD") });
                    }}
                  />
                </div>
                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6">
                  <CustomTimePicker
                    timeValue={timeValue}
                    setTimeValue={setTimeValue}
                    appointment={appointment}
                    setAppointment={setAppointment}
                    setHourValue={setHourValue}
                    setMinuteValue={setMinuteValue}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center sm-hide">
              <i className="bx bx-video"></i>
            </div>
            <div className="col-lg-11 col-md-11 col-sm-11 col-xs-12">
              Video - 1 Hour Session
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center sm-hide">
              <i className={Util.meetingRepeatTypeIcon(appointment.repeat)}></i>
            </div>
            <div className="col-lg-11 col-md-11 col-sm-11 col-xs-12">
              <Input
                type="select"
                name="repeat"
                onChange={e => setAppointment({ ...appointment, repeat: e.target.value })}
                value={appointment.repeat}
              >
                <option value={Repeat.DOES_NOT_REPEAT}>Does Not Repeat</option>
                <option value={Repeat.WEEKLY}>Weekly</option>
                <option value={Repeat.BI_WEEKLY}>Bi Weekly</option>
              </Input>
            </div>
          </div>

          {/* Hidden - This is a Tentative Appointment checkbox */}
          <div className="row mb-4" style={{ display: 'none' }}>
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center sm-hide"></div>
            <div className="col-lg-11 col-md-11 col-sm-11 col-xs-12">
              <div 
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  const newValue = !isTentativeAppointment;
                  setIsTentativeAppointment(newValue);
                  if (newValue) {
                    setAppointment({ ...appointment, color: "#6c757d" }); // Grey color for tentative
                  } else {
                    setAppointment({ ...appointment, color: "#FF6900" }); // Default orange
                  }
                }}
              >
                <input 
                  type="checkbox" 
                  checked={isTentativeAppointment}
                  readOnly
                  style={{ marginRight: '8px', pointerEvents: 'none' }}
                />
                <span>This is a Tentative Appointment</span>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center sm-hide">
              <i className="bx bx-palette"></i>
            </div>
            <div className="col-lg-11 col-md-11 col-sm-11 col-xs-12">
              <TwitterPicker 
                width="100%" 
                onChangeComplete={handleChangeComplete} 
                color={appointment.color}
                triangle="hide"
                colors={isTentativeAppointment ? ['#6c757d'] : ['#1890ff', '#f5222d', '#fa8c16', '#FF6900', '#52c41a', '#13c2c2', '#722ed1', '#eb2f96']}
              />
            </div>
          </div>

          {therapistDetails.disclosureStatementId?.url && (
            <div className="row mb-4">
              <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center sm-hide"></div>
              <div className="col-lg-11 col-md-11 col-sm-11 col-xs-12">
                <FormGroup check inline>
                  <Input type="checkbox" onChange={(e) => setHaveRead(e.target.checked)} />
                  <Label check>
                    I have read the&nbsp;
                    <a href={Util.fileURL(therapistDetails.disclosureStatementId._id)} target="_blank" rel="noopener noreferrer">
                      disclosure statement&nbsp;
                    </a>
                    & Accept.
                  </Label>
                </FormGroup>
              </div>
            </div>
          )}

          {/* <div className="row mb-4">
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center sm-hide"></div>
            <div className="col-lg-11 col-md-11 col-sm-11 col-xs-12">
              <FormGroup check inline>
                <Input type="checkbox" onChange={(e) => setHaveAgreedPolicy(e.target.checked)} />
                <Label check>
                  I agree to&nbsp;
                  <a href="/noshow-policy" className="hover" target="_blank" rel="noopener noreferrer">
                    No Show and Cancellation Policy&nbsp;
                  </a>
                  of Lavni Inc.
                </Label>
              </FormGroup>
            </div>
          </div> */}

          {/* <div className="row mb-4">
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center sm-hide"></div>
            <div className="col-lg-11 col-md-11 col-sm-11 col-xs-12">
              <FormGroup check inline>
                <Input type="checkbox" onChange={(e) => setHaveAgreed(e.target.checked)} />
                <Label check>
                  I agree to&nbsp;
                  <a href="/consent-document" className="hover" target="_blank" rel="noopener noreferrer">
                    Consent Document&nbsp;
                  </a>
                  of Lavni Inc.
                </Label>
              </FormGroup>
            </div>
          </div> */}

          <div className="row">
            <div className="col-lg-1 cont-center"></div>
            <div className="col appoint-btn">
              <button 
                className={disabledCreateBtn ? "session-btn updating" : "session-btn"} 
                disabled={disabledCreateBtn} 
                onClick={createAppointment}
              >
                {isTentativeAppointment ? "Create Tentative Appointment" : "Create"}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* View Event Modal */}
      <Modal isOpen={isEventViewModal} centered toggle={eventViewModalToggle}>
        <div className="modal-header">
          <h5 className="modal-title">Session Details</h5>
        </div>
        <div className="modal-body">
          <div className="row mb-2">
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center1 sm-hide">
              <i className="bx bx-time-five"></i>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
              <h5>
                {moment(appointmentDetails?.start).format("dddd")}, {moment(appointmentDetails?.start).format("MMM Do YY")}
              </h5>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
              <h5>{moment(appointmentDetails?.start).format("h:mm A")}</h5>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
              <h5>{moment(appointmentDetails?.end).format("h:mm A")}</h5>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 cont-center1 sm-hide">
              <i className="bx bx-video"></i>
            </div>
            <div className="col">
              <h5>Video - 1 Hour Session</h5>
            </div>
          </div>
        </div>
      </Modal>

      {/* Error Modal */}
      <Modal isOpen={isEventTimeValidationViewModal} centered toggle={eventTimeValidationModalToggle}>
        <div className="modal-body">
          <div className="modal-val">
            <h5 className="model-error">{errorModalText}</h5>
            <button className="btn btn-sm text-center btn-success mt-3" onClick={eventTimeValidationModalToggle}>
              Got It
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SchedulingCalendar;